import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

export const useIncreaseScoreTips = (props, pagePosition) => {
  const { eventHandler } = props;

  const onLinkClick = () => {
    eventHandler(CLICK, {
      'Click Type': 'See what you can do',
      'Module Name': pagePosition,
      Vertical: AUTO_LOAN_VERTICAL,
    });
  };
  return {
    onLinkClick,
  };
};
